<template>
  <div class="quick-start-guides">
    <Layout ref="layoutRef" :selectedOption="4" />
    <div v-if="modulo==0">
      <router-link to="/MenuPrincipal">Inicio</router-link>
    </div>
    <h4>Guías de Inicio Rápido</h4>
    <hr>
    <p>Encuentra aquí información esencial para comenzar a utilizar el sistema de forma rápida y eficiente.</p>      
    <div class="guides-list">
      <div class="guide" v-for="(guide, index) in guides" :key="index">
        <h5>{{ guide.title }}</h5>
        <p>{{ guide.description }}</p>
        <router-link :to="guide.link">Leer más</router-link>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Layout from '@/components/Layout.vue';
import Footer from '@/components/Footer.vue';
import { guides } from '@/router/guidesRoutes.js';

export default {
  name: "QuickStartGuides",
  components: {
    Layout,
    Footer
  },
  data() {
    return {
      guides,
      modulo: 0,
    };
  },
  mounted () {
    this.modulo = window.sessionStorage.getItem("modulo")
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  }
};
</script>

<style scoped>
.quick-start-guides {
  padding: 20px;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.guides-list .guide {
  margin-bottom: 20px;
  background-color: #ffffff;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0 3px 5px rgba(0,0,0,0.05);
  border-left: 5px solid #007BFF;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.guides-list .guide:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
}

.guides-list .guide h5 {
  color: #3b3b3b;
  margin-top: 0;
  font-size: 1.25rem;
}

.guides-list .guide p {
  color: #5b5b5b;
  line-height: 1.6;
}

.guides-list .guide a {
  color: #007BFF;
  text-decoration: none;
  font-weight: bold;
  transition: color 0.3s ease;
}

.guides-list .guide a:hover {
  color: #0056b3;
}
</style>